import { synthesizeDataWithJSONSchema } from '@criteria/synthetic-data';
export function exampleForMediaType(mediaType) {
    const { schema, example, examples = {} } = mediaType;
    if (example !== undefined) {
        return example;
    }
    if (Object.keys(examples).length > 0) {
        return examples[Object.keys(examples)[0]];
    }
    return synthesizeDataWithJSONSchema(schema !== null && schema !== void 0 ? schema : {});
}
